import packDataService from "../../services/packsDataService";
import { type AppDispatch } from "../../../../Application/globaltypes/redux";
import { req, err, got } from "../slices/packLicenseTypesSlice";

export const fetchPackLicenseTypes = () => async (dispatch: AppDispatch) => {
  dispatch(req());
  try {
    const res = await packDataService.getPackLicensesTypesAsync();
    dispatch(got({ items: res.data, totalCount: res.data.length }));
  } catch (e) {
    let errorMessage = (e as Error).message;
    dispatch(err(errorMessage));
  }
};
